var React = require('react');

function Damp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"EWar Battery"),React.createElement("g",{"id":"layer1","key":2},React.createElement("g",{"id":"g1605"},[React.createElement("path",{"id":"path4015-1-1","className":"cls-1","d":"M74,34H34L24,44V84L34,94H74","key":0}),React.createElement("path",{"id":"path4165","className":"cls-1","d":"M94,34,74,54V74L94,94","key":1}),React.createElement("path",{"id":"path4167","className":"cls-1","d":"M74,64h30","key":2})]))]);
}

Damp.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Damp;

Damp.default = Damp;
